import { useState, useEffect } from "react";
import {Link,Navigate} from 'react-router-dom';
import { ru } from '../../data/ru';
import { by } from '../../data/by';
import API from "../../API";
import {TEST_URL} from "../../../config";

const AvailableTests = () => {
  let language = localStorage.getItem('lang') === 'ru' ?  ru.RoleIdFour: by.RoleIdFour;
  const api = new API();
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [items, setItems] = useState([]);
  
    useEffect(() => {
        api.getUserTests(localStorage.getItem('id'))
        .then(
          (result) => {
            setIsLoaded(true);
            setItems(result);
          },
          (error) => {
            setIsLoaded(true);
            setError(error);
          }
        )
    }, [])
    
    const style = {
        color: '#3788de'
    }
    const [isTestStart,setIsTestStart]=useState(false)
    const [idTest,setIdTest]= useState();
    const onClickHandler =(id)=>{
        // localStorage.setItem('startedTestId', id)
        setIdTest(id);
        setIsTestStart(true);
    }
    if (error) {
      return <div>Ошибка: {error.message}</div>;
    } else if (!isLoaded) {
      return <div>Загрузка...</div>;
    } else {
      return (
          <>
              {!isTestStart ?
        <div className="student_available_test">
            <ol className="student_list_bullet">
            {items.tests.length !== 0 ? items.tests.map(item => (
                <li key={item.id} onClick={e=>onClickHandler(item.id)}>
                    {/*<Link >{item.name}{localStorage.setItem('startedTestId', item.id)}</Link>*/}
                    {item.name}
                </li>
            )) : <h4 style={style}>{language.textForAvailableTest}</h4>}
            </ol>
        </div> : <Navigate to={TEST_URL+'/'+idTest}/>}
          </>
      );
    }
}

export default AvailableTests;